import React, { Fragment, useState } from 'react'
import { Logo } from '../Logo'
import { SearchContainer } from '../Search'
import GuestUserProfile from './GuestUserProfile'
import GuestCart from './GuestCart'
import Helmet from 'react-helmet'
import HeaderWrapper from '../HeaderWrapper'
import { MainMenuPublicContainer } from 'App/MainMenu'
import yn from 'yn'

const defaultState = {
  isMessageClosed: window.localStorage.getItem('isMessageClosed') || false
}

const GuestHeader = () => {
  const [ownState, setOwnState] = useState(defaultState)

  const closeMessage = () => {
    setOwnState({
      ...ownState,
      isMessageClosed: true
    })
    window.localStorage.setItem('isMessageClosed', true)
    document.querySelectorAll('#meu-negocio').length > 0 && document.querySelector('#meu-negocio').focus()
  }

  return (
    <Fragment>
      <HeaderWrapper closeMessage={closeMessage} {...ownState}>
        {yn(process.env.REACT_APP_NO_INDEX) && (
          <Helmet>
            <meta name='robots' content='noindex, nofollow' />
          </Helmet>
        )}
        <Logo />
        <SearchContainer />
        <GuestUserProfile />
        {window.innerWidth > 767 ? <GuestCart /> : ''}
      </HeaderWrapper>
      <MainMenuPublicContainer />
    </Fragment>
  )
}

export default GuestHeader



// WEBPACK FOOTER //
// ./src/App/Header/GuestHeader/GuestHeader.js